import { useState } from "react";

/**
 * DateRangeInput component - Provides inputs for selecting a start and end date.
 *
 * @param {Object} props - Component props.
 * @param {string} props.startDate - The currently selected start date in "YYYY-MM-DD" format.
 * @param {() => void} props.setStartDate - Function to update the start date.
 * @param {() => void} props.endDate - The currently selected end date in "YYYY-MM-DD" format.
 * @param {function} props.setEndDate - Function to update the end date.
 *
 * @returns {JSX.Element} The DateRangeInput component.
 */
export const DateRangeInput = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}) => {
  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  return (
    <div
      style={{
        display: "flex",
        gap: "1rem",
        flexWrap: "wrap",
        padding: "10px 0",
      }}
    >
      <label>
        <div style={{ marginBottom: "5px" }}>Start Date:</div>
        <input
          type="date"
          value={startDate}
          onChange={handleStartDateChange}
          style={{
            padding: "10px",
            border: "1px solid rgb(84, 93, 101)",
            borderRadius: "10px",
          }}
        />
      </label>
      <label>
        <div style={{ marginBottom: "5px" }}>End Date:</div>
        <input
          type="date"
          value={endDate}
          onChange={handleEndDateChange}
          style={{
            padding: "10px",
            border: "1px solid rgb(84, 93, 101)",
            borderRadius: "10px",
          }}
        />
      </label>
    </div>
  );
};
